

















































import { Vue, Component, Prop } from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import HexColor from './hex-color.component.vue';

@Component({
  components: {
    LabelSlot,
    HexColor,
  },
})
export default class HexColorPicker extends Vue {
  @Prop({ type: String, default: 'Cor' })
  label!: string;

  @Prop({ type: String, required: true })
  value!: string;

  @Prop({ type: Array, default: () => ([]) })
  rules!: Array<any>;

  @Prop({ type: Boolean, default: false })
  readonly!: boolean;

  pulseColor: boolean = false;

  onColorClick(): void {
    if (this.readonly) return;
    this.pulseColor = true;
    setTimeout(() => {
      this.pulseColor = false;
    }, 1500);
  }

  updateColor(value: any): void {
    this.$emit('input', value.hex);
  }
}
